import { render } from "./FormProperties.vue?vue&type=template&id=250f38b3&scoped=true"
import script from "./FormProperties.vue?vue&type=script&lang=js"
export * from "./FormProperties.vue?vue&type=script&lang=js"

import "./FormProperties.vue?vue&type=style&index=0&id=250f38b3&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-250f38b3"

export default script